import { routeKeys } from "@/api/Routes";
import { activityKeys } from "@/api/Activities";
import { patientKeys } from "@/api/Patients";
import { useEventSource } from "@/Utils/sse";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";

const AGGREGATE_CHANGED_SSE = "aggregateChanged";

// These keys are the parents of every known logistics query (shifts excluded), dealing with activities, routes etc.
const ALL_GO_RELEVANT_LOGISTICS_QUERY_KEYS = [routeKeys.all, activityKeys.all];

export const useGoLogisticsSSEHandlers = () => {
  const queryClient = useQueryClient();
  // https://react.dev/reference/react/useMemo#caveats says to prefer useState for safely persisting state between renders: https://react.dev/reference/react/useState#avoiding-recreating-the-initial-state
  const [eventHandlers] = useState(() => [
    {
      relevantEvents: [AGGREGATE_CHANGED_SSE],
      handler: () => {
        ALL_GO_RELEVANT_LOGISTICS_QUERY_KEYS.forEach((queryKey) => {
          void queryClient.invalidateQueries({ queryKey });
        });
      },
    },
  ]);
  useEventSource("logistics", eventHandlers);
};

export const useGoPatientSSEHandlers = () => {
  const queryClient = useQueryClient();
  // https://react.dev/reference/react/useMemo#caveats says to prefer useState for safely persisting state between renders: https://react.dev/reference/react/useState#avoiding-recreating-the-initial-state
  const [eventHandlers] = useState(() => [
    {
      relevantEvents: [AGGREGATE_CHANGED_SSE],
      handler: () => {
        void queryClient.invalidateQueries({ queryKey: patientKeys.all });
      },
    },
  ]);
  useEventSource("patient", eventHandlers);
};
